// this compoenent
import React from 'react'
import PropTypes from 'prop-types'
import style from './Indicator.less'

const getColor = (value, colors, threshold, isBoolean) => {
  if (isBoolean) return value ? colors[1] : colors[0]
  return threshold.reduce((c, current, i) => {
    return current < value ? colors[i + 1] || c : c
  }, colors[0])
}

const Indicator = ({ value, colors, unit, title, threshold, type, width }) => {
  let color = colors ? getColor(value, colors, threshold, !unit) : '#000'
  return (
    <span className={style.indicator} style={{ width, height: 55 }}>
      <span
        className={`icon ${type || ''}`}
        style={{ color: color }}
      />
      <span className='text'>
        <span className='data' style={{ color: color }}>
          {unit
            ? Math.floor(value * 10) / 10 + ` ${unit}`
            : value ? 'ON' : 'OFF'
          }
        </span><br />
        <span className='tittle'>
          {title.toUpperCase()}
        </span>
      </span>
    </span>
  )
}

Indicator.propTypes = {
  type: PropTypes.string,
  unit: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.number,
  width: PropTypes.number,
  colors: PropTypes.array
}

export default Indicator



// WEBPACK FOOTER //
// ./src/charts/Indicator.js